import React from 'react'
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <div>
      <div className='footer-panel'>

        <div class="footer-nav-panel">
            <Link to="/">Footer Link</Link>
            <Link to="/">Footer Link</Link>
            <Link to="/">Footer Link</Link>
            <Link to="/">Footer Link</Link>
            <Link to="/">Footer Link</Link>
            <Link to="/">Footer Link</Link>
            <Link to="/">Footer Link</Link>
            <Link to="/">Footer Link</Link>
        </div>

      </div>
    </div>
  )
}

export default Footer
